import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackGoToReliableHouseListing } from './tracking';
import { ReliabilityHouses } from '../../components/Reliability/ReliabilityHouses';
import { getReliableHouses } from '../../selectors/newbuilding';

export function ReliabilityHousesContainer() {
  const reliableHouses = useSelector(getReliableHouses);

  if (reliableHouses.length === 0) {
    return null;
  }

  return <ReliabilityHouses houses={reliableHouses} onClick={trackGoToReliableHouseListing} />;
}
